/* tslint:disable */
/* eslint-disable */
export enum DriverLicenseTypeEnum {
  Learners = 'Learners',
  Restricted = 'Restricted',
  Full = 'Full',
  SpecialConditions = 'SpecialConditions'
}
